// useActivateCardQuery

import { useQuery } from 'react-query';
import { httpService } from '../../services/http.service';
import { BASE_URL, USER } from '../../constants/endpoints';
import { ACTIVATION_FLOWS } from '../../flows/liliCard/constants';
import { HOOKS_SETTINGS } from '../constants';

export interface IPayload {
  last4Card: string;
  last4SSN?: string;
  expirationDate?: string;
}

const {
  CONTROLLERS: {
    ACTIVATE_CARD: {
      VERSION, BASE, TYPE_SSN, TYPE_EXP_DATE,
    },
  },
} = USER;
const { METHOD: { POST } } = HOOKS_SETTINGS;
const { SSN } = ACTIVATION_FLOWS;

export const useActivateCardQuery = ({
  customerId, activationType, cardId, payload, onSuccess, onFailure,
}: {customerId: string, activationType: string, cardId: string, payload: IPayload, onSuccess?: () => void, onFailure?: () => void }) => useQuery(
  ['ActivateCard'],
  async () => {
    if (!customerId || !cardId || (!payload.expirationDate && !payload.last4SSN) || !payload.last4Card) {
      return '';
    }
    const DATA_PAYLOAD = activationType === SSN ? {
      lastFourCard: payload.last4Card,
      lastFourSsn: payload.last4SSN,
    } : {
      lastFour: payload.last4Card,
      expiryDate: payload.expirationDate,
      cardId,
    };
    const ACTIVATION_TYPE = activationType === SSN ? TYPE_SSN : TYPE_EXP_DATE;
    const { data } = await httpService({
      url: `${BASE_URL}/api/${VERSION}/user/${customerId}/${BASE}/${cardId}/${ACTIVATION_TYPE}`,
      method: POST,
      data: {
        ...DATA_PAYLOAD,
      },
    });
    return data;
  },
  {
    enabled: false,
    retry: false,
    onSuccess: () => { if (onSuccess) onSuccess(); },
    onError: () => { if (onFailure) onFailure(); },
  },
);
